import isNil from 'lodash-es/isNil'
import isObject from 'lodash-es/isObject'

// TODO: translate
const MONTHS = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
]

export function formatDateParts({ year, month, day }) {
  const result = {}

  if (day) {
    const parsed = parseInt(day, 10) || undefined
    if (parsed) {
      result.day = `${parsed}`
    }
  }

  if (month) {
    const parsed = parseInt(month, 10) || undefined
    if (parsed && parsed <= MONTHS.length) {
      result.month = MONTHS[parsed - 1]
    }
  }

  if (year) {
    result.year = `${year}`
  }

  return result
}

export function formatDate(date) {
  if (!isObject(date)) {
    return date
  }

  const { year, month, day, hour, minute } = date
  const result = []

  if (!isNil(year) && !isNil(month) && !isNil(day)) {
    result.push(
      [year, month, day]
        .map(p => `${p}`.padStart(2, '0'))
        .join('/'),
    )
  }

  if (!isNil(hour) && !isNil(minute)) {
    result.push(
      [hour, minute]
        .map(p => `${p}`.padStart(2, '0'))
        .join(':'),
    )
  }

  return result.join(' - ')
}
